
import $ from "jquery"

const CLASS_NAME_ON_EXPANDED = "cell--buildings--description-text--box--sometimes-collapsed-style--expanded"

export default function onLoad() {
  const $cells = $(".cell--buildings--description-text--box--sometimes-collapsed-style")
  if ($cells.length === 0) { return }

  $cells.each((_idx, el) => {
    const $cell = $(el)
    const $expand_button = $cell.find(".cell--buildings--description-text--box--sometimes-collapsed-style__btn-see-more")
    if ($expand_button.length === 0) { return }

    $expand_button.on("click", (() => $cell.addClass(CLASS_NAME_ON_EXPANDED)))
  })
}
